export const inputPlaceholder = "AC/DC Highway To Hell";
export const timePlaceholder = "mm:ss";
export const rowStyling = "mb-2";
export const labelStyling = "w-25 justify-content-center";
